// extracted by mini-css-extract-plugin
export default {"tagContainer":"Tag-module--tagContainer--79943","iconContainer":"Tag-module--iconContainer--715c3","icon":"Tag-module--icon--10286","pointer":"Tag-module--pointer--e9409"};